export default __webpack_public_path__ + "static/ukzn-logo-7469760570447f5741e00c2e57c3dd72.svg";